import React, { useEffect, useState } from 'react';

const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

function buildLogoSrc(logoUrl) {
  if (!logoUrl) return '/logo-216.png';
  if (/^https?:\/\//i.test(logoUrl)) return logoUrl;
  return `${API_BASE}${logoUrl}`;
}

export default function Logo({ onHomeClick, logoUrl, variant = 'header' }) {
  const [src, setSrc] = useState(buildLogoSrc(logoUrl));

  useEffect(() => {
    setSrc(buildLogoSrc(logoUrl));
  }, [logoUrl]);

  const isPowerLogo = src.toLowerCase().includes('power-logo');

  const sizeClass = {
    header: 'h-12 max-w-[170px]',
    footer: 'h-14 max-w-[190px]',
    loading: 'h-20 max-w-[240px]',
  }[variant] || 'h-12 max-w-[170px]';

const powerScale = {
  header: 2.5,
  footer: 2.3,
  loading: 1,
}[variant] || 2.5;

  return (
    <div
      className={`flex items-center gap-3 transition-opacity ${onHomeClick ? 'cursor-pointer hover:opacity-80' : ''}`}
      onClick={onHomeClick}
      role={onHomeClick ? 'button' : undefined}
      tabIndex={onHomeClick ? 0 : undefined}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && onHomeClick) {
          onHomeClick();
        }
      }}
    >
      <img
        src={src}
        alt="Logo"
        className={`${sizeClass} w-auto object-contain block`}
        style={{
          transform: isPowerLogo ? `scale(${powerScale})` : 'scale(1)',
          transformOrigin: 'left center',
        }}
        onError={() => setSrc('/logo-216.png')}
      />
    </div>
  );
}
